import Stylus from './Stylus';
import SmartObjectDrawingBrush from './SmartObjectDrawingBrush';
import styles from '../styles.module.css';
import { labeledMenuComponent } from '../utils/stylus';
import { svgToIcon } from '../utils/svg';
import shapeSmartObject from '../assets/icons/shapeSmartObject.svg';

// Create new smart objects.
class StylusSmartObject extends Stylus {
  constructor({ controller }) {
    super({ controller });
  }

  stylusId() {
    return 'smartObject';
  }

  activate() {
    const brush = new SmartObjectDrawingBrush(this.controller.canvas, this);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  renderIcon() {
    return svgToIcon(shapeSmartObject);
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  cursor() {
    return 'crosshair';
  }

  description() {
    return 'Smart shape';
  }
}

export default StylusSmartObject;
